import { useContext, useEffect, useState } from "react";
import Select from "react-select";
import { CartContext } from "../../context/cartContext";
import { DeliveryOptionContext } from "../../context/deliveryOptionContext";

import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";

import Image from "../../components/atoms/image";
import Text from "../../components/atoms/text";
import { XIconBlack } from "../../utils/iconList";
import styles from "./gateSelectionModal.module.css";

import Button from "../../components/atoms/button";
import config from "../../config/config";

import moment from "utils/momentWrapper";
import BoardingPassIcon from "../../assets/images/landing/boarding_pass_icon.svg";
import SearchIcon from "../../assets/images/landing/magnifying_glass.svg";
import Loader from "../../components/molecules/loader";
import { isTab, sendMessageToReactNative } from "../../utils/helperFunctions";

function GateSelectionModal(props) {
  const useDelivery = useContext(DeliveryOptionContext);
  const useCart = useContext(CartContext);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedGate, setSelectedGate] = useState(null);
  const [gates, setGates] = useState([]);
  const style = {
    position: "absolute",
    top: isTab() ? "calc(35% + 30px)" : "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: isTab() ? "calc(100% - 60px)" : "954px",
    height: isTab() ? "fit-content" : 969,
    bgcolor: "background.paper",
    border: "none",
    boxShadow: 24,
    borderRadius: 12,
  };

  useEffect(() => {
    getGateListing();
  }, []);

  useEffect(() => {
    if (
      Object.keys(useDelivery.selectedDeliveryOption).length > 0 &&
      useDelivery.selectedDeliveryOption.deliveryOption === "collect at gate"
    ) {
      setSelectedGate({
        label: useDelivery.selectedDeliveryOption.deliveryAddress.split(" ")[1],
        value: useDelivery.selectedDeliveryOption.deliveryAddress.split(" ")[1],
      });
    }

    return () => {
      setSelectedGate(null);
    };
  }, [useDelivery.selectedDeliveryOption]);

  const getGateListing = () => {
    try {
      const data = JSON.parse(localStorage.getItem("gateList"));
      setGates([...data]);
      setIsLoading(false);
    } catch (e) {
      console.log(e);
    }
  };

  const ClearIndicator = () => {
    return <></>;
  };

  const DropdownIndicator = () => {
    if (selectedGate === null || selectedGate === undefined) {
      return <Image src={SearchIcon} className={styles.search_icon} />;
    } else return null;
  };

  const IndicatorSeparator = () => {
    return <></>;
  };

  const onSubmit = () => {
    if (selectedGate && selectedGate !== undefined) {
      let selectedDeliveryOption = {
        deliveryOption: config.deliveryOptions.deliveryAtGate,
        deliveryAddress: `Gate ${selectedGate.value}`,
        deliveryTime: moment(new Date(), "UTC", "UTC").format(),
        isPackagingRequested: true,
      };
      useDelivery.handleDeliverySelection(selectedDeliveryOption);
      useCart.updateDeliveryOptions(selectedDeliveryOption);
      setSelectedGate(null);
      props.handleSubmit();
      sendMessageToReactNative("Analytics_Opt_For_Delivery");
      sendMessageToReactNative(`Analytics_Opt_For_Gate_${selectedGate.value}`);
    }
  };

  return (
    <Modal
      open={props.open}
      onClose={props.handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <div className={styles.gate_modal_container}>
          <div className={styles.close_button_container}>
            <div className={styles.close_button}>
              <Image
                src={XIconBlack}
                style={{ width: "100%", height: "100%" }}
                onClick={props.handleClose}
              />
            </div>
          </div>
          <div className={styles.modal_content_container}>
            {isLoading ? (
              <Loader />
            ) : (
              <>
                <div className={styles.modal_header_text}>
                  <Text>Which gate should we deliver to? 📦</Text>
                </div>
                <div className={styles.sub_text}>
                  <Image
                    src={BoardingPassIcon}
                    className={styles.boarding_pass_icon}
                  />
                  <div className={styles.disclaimer_text}>
                    <Text>
                      Find your gate number on your <b>Boarding Pass</b> or{" "}
                      <b>Flight Ticket</b> so we can deliver to you
                    </Text>
                  </div>
                </div>
                <div
                  className={styles.gate_select_wrapper}
                  style={{ position: "relative" }}
                >
                  <Select
                    components={{
                      ClearIndicator,
                      DropdownIndicator,
                      IndicatorSeparator,
                    }}
                    styles={{
                      valueContainer: (base) => ({
                        ...base,
                        fontSize: isTab() ? "18px" : "36px",
                        fontWeight: "500",
                        lineHeight: isTab() ? "14px" : "28px",
                        letterSpacing: "0.35px",
                        color: "#181818",
                        paddingLeft: isTab() ? "20px" : "40px",
                        fontFamily: "Manrope",
                      }),
                      control: (base) => ({
                        ...base,
                        minHeight: isTab() ? "60px" : "121px",
                        borderRadius: isTab() ? "9px" : "18px",
                        border: isTab()
                          ? "1px solid #DCDCDC"
                          : "2px solid #DCDCDC",
                        boxShadow: "none",
                        "&:hover": {
                          border: isTab()
                            ? "1px solid #DCDCDC"
                            : "2px solid #DCDCDC",
                        },
                      }),
                      menu: (base) => ({
                        ...base,
                        boxShadow: "none",
                        borderRadius: isTab() ? "9px" : "18px",
                        marginTop: "5px",
                        marginBottom: "8px",
                      }),
                      option: (base) => ({
                        ...base,
                        border: `1px solid #DCDCDC`,
                        display: "flex",
                        alignItems: "center",
                        height: isTab() ? "55px" : "113px",
                        fontSize: isTab() ? "16px" : "36px",
                        fontWeight: "500",
                        lineHeight: isTab() ? "16px" : "49px",
                        color: "#000000",
                        padding: isTab() ? "16px 24px" : "32px 56px",
                        backgroundColor: "#fff",
                      }),
                      singleValue: (base) => ({
                        ...base,
                        fontSize: isTab() ? "16px" : "36px",
                        fontWeight: "500",
                        lineHeight: isTab() ? "16px" : "28px",
                        letterSpacing: "0.35px",
                        color: "#181818",
                        fontFamily: "Manrope",
                      }),
                      noOptionsMessage: (base) => ({
                        ...base,
                        fontSize: isTab() ? "16px" : "36px",
                        fontWeight: "500",
                        lineHeight: isTab() ? "16px" : "28px",
                        letterSpacing: "0.35px",
                        color: "#181818",
                        fontFamily: "Manrope",
                      }),
                    }}
                    placeholder={"Your boarding gate e.g. 34A"}
                    isClearable={true}
                    value={selectedGate}
                    onChange={(e) => setSelectedGate(e)}
                    options={gates}
                    maxMenuHeight={isTab() ? "120px" : "300px"}
                  />
                  {selectedGate !== null && selectedGate !== undefined && (
                    <div
                      onClick={() => setSelectedGate(null)}
                      className={styles.clear_text_wrapper}
                    >
                      <div className={styles.clear_text}>
                        <Text>Clear</Text>
                      </div>
                    </div>
                  )}
                </div>
                <div className={styles.gate_select_button}>
                  <Button
                    style={{
                      backgroundColor: "var(--primary)",
                      borderRadius: "206px",
                      border: "none",
                      opacity:
                        selectedGate === null || selectedGate === undefined
                          ? "0.3"
                          : "1",
                    }}
                    className={styles.gate_select_button}
                    disabled={
                      selectedGate === null || selectedGate === undefined
                        ? true
                        : false
                    }
                    onClick={() => onSubmit()}
                  >
                    <div className={styles.gate_select_button_label}>
                      <Text>Confirm gate</Text>
                    </div>
                  </Button>
                </div>
              </>
            )}
          </div>
        </div>
      </Box>
    </Modal>
  );
}

export default GateSelectionModal;
